document.addEventListener('DOMContentLoaded', function () {

  // Add-to-cart is now handled entirely by the theme's own 'buy-buttons'
  // snippet rendered in each card, so no custom add-to-cart JS lives here
  // anymore — the theme's native cart/AJAX/drawer behavior applies as-is.

  // ---- Carousel: navigation, video autoplay, play/pause toggle, variants --
  // Wrapped per-section in try/catch: a problem in one carousel instance
  // should never stop other sections (or add-to-cart, above) from working.
  document.querySelectorAll('[data-video-carousel]').forEach(function (root) {
    try {
      initCarousel(root);
    } catch (err) {
      console.error('[video-carousel] failed to initialize a carousel:', err);
    }
  });

  function initCarousel(root) {
    var track = root.querySelector('[data-vc-track]');
    var prevBtn = root.querySelector('[data-vc-prev]');
    var nextBtn = root.querySelector('[data-vc-next]');
    if (!track) return;

    function scrollAmount() {
      var slide = track.querySelector('.video-carousel__slide, .vc-card');
      var width = slide ? slide.getBoundingClientRect().width : 260;
      return width + 18; // card width + gap from CSS
    }

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function updateArrowVisibility() {
      var hasOverflow = maxScroll() > 2;
      if (prevBtn) prevBtn.style.display = hasOverflow ? '' : 'none';
      if (nextBtn) nextBtn.style.display = hasOverflow ? '' : 'none';
    }

    updateArrowVisibility();
    window.addEventListener('resize', updateArrowVisibility);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (track.scrollLeft <= 2) {
          track.scrollTo({ left: maxScroll(), behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (track.scrollLeft >= maxScroll() - 2) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        }
      });
    }

    // Play the video only while its card is actually visible in the carousel,
    // unless the shopper has manually paused it (respected until it scrolls
    // out of view again).
    var videos = root.querySelectorAll('[data-vc-video]');
    if ('IntersectionObserver' in window && videos.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var vid = entry.target;
            if (entry.isIntersecting) {
              if (vid.dataset.userPaused !== 'true') {
                var playPromise = vid.play();
                if (playPromise && playPromise.catch) playPromise.catch(function () {});
              }
            } else {
              vid.pause();
              vid.dataset.userPaused = 'false'; // reset so it autoplays again next time it scrolls into view
            }
          });
        },
        { root: track, threshold: 0.6 }
      );
      videos.forEach(function (v) { observer.observe(v); });
    } else {
      // Fallback: just try to autoplay everything (muted, so browsers allow it).
      videos.forEach(function (v) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      });
    }

    root.querySelectorAll('[data-vc-card]').forEach(function (card) {
      // Manual play/pause toggle button.
      var video = card.querySelector('[data-vc-video]');
      var toggle = card.querySelector('[data-vc-toggle]');
      if (video && toggle) {
        var syncButton = function () {
          toggle.classList.toggle('is-playing', !video.paused);
        };

        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation(); // don't let the click bubble to the product link
          if (video.paused) {
            video.dataset.userPaused = 'false';
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.dataset.userPaused = 'true';
            video.pause();
          }
        });

        video.addEventListener('play', syncButton);
        video.addEventListener('pause', syncButton);
        syncButton();
      }

      // Variant selector: keeps price, compare-at price, discount badge, and
      // title in sync with the picked option. (Add-to-cart itself is now the
      // theme's own 'buy-buttons' snippet, which manages its own variant.)
      var select = card.querySelector('[data-vc-variant-select]');
      if (select) {
        var priceEl = card.querySelector('[data-vc-price]');
        var compareEl = card.querySelector('[data-vc-compare]');
        var badgeEl = card.querySelector('[data-vc-discount-badge]');
        var titleEl = card.querySelector('[data-vc-title]');

        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          if (!opt) return;

          var hasDiscount = opt.getAttribute('data-has-discount') === 'true';

          if (priceEl) priceEl.textContent = opt.getAttribute('data-price');

          if (compareEl) {
            if (hasDiscount) {
              compareEl.textContent = opt.getAttribute('data-compare');
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }

          if (badgeEl) {
            if (hasDiscount) {
              badgeEl.textContent = '-' + opt.getAttribute('data-discount-pct') + '%';
              badgeEl.hidden = false;
            } else {
              badgeEl.hidden = true;
            }
          }

          if (titleEl) {
            var baseTitle = titleEl.getAttribute('data-base-title') || '';
            var variantTitle = opt.getAttribute('data-title');
            titleEl.textContent = (variantTitle && variantTitle !== 'Default Title')
              ? baseTitle + ' - ' + variantTitle
              : baseTitle;
          }
        });
      }
    });
  }
});
